// Who may read the Initiative Roadmap, and how much of it — the frontend twin
// of the gates in app/routes/roadmap_reports.py (owner ask 2026-10-15:
// "everyone sees the roadmap for all teams, just like the main roadmap admins
// see, and can filter to mine"; "scope-based").
//
//   reader      roadmap:read (every role's default for now), exec:portal or
//               ADMIN — the roadmap data: initiatives, questions, timeline,
//               what changed, the org chart, the source and run ledgers.
//   leadership  exec:portal or ADMIN — also the run reports (Delta supplier
//               pricing) and the source documents (meeting transcripts, emails).
//   canRun      ADMIN — queue a run, answer any question, park.
//   canEditTeams roadmap:edit-teams (every role's default for now), exec:portal
//               or ADMIN — fix a misidentified team: set the owning / related
//               teams and the mandate area, or release that pin (owner ask
//               2026-10-21: "the edit teams button needs to be on everyone's
//               road map so they can fix a misidentified team"). The one
//               roadmap write that is not admin-only.
//
// A reader who is not leadership keeps the whole page; only the Reports
// surface and the source viewer are off (roadmapTabs.LEADERSHIP_TABS).

import { EXEC_PORTAL_SCOPE } from '../../constants/execPortal';

export const ROADMAP_READ_SCOPE = 'roadmap:read';
export const ROADMAP_EDIT_TEAMS_SCOPE = 'roadmap:edit-teams';

export interface RoadmapAccess {
  reader: boolean;
  leadership: boolean;
  canRun: boolean;
  canEditTeams: boolean;
}

interface AuthLike {
  user: { role: string } | null;
  hasScope: (scope: string) => boolean;
}

export function roadmapAccess({ user, hasScope }: AuthLike): RoadmapAccess {
  const admin = user?.role === 'ADMIN';
  const leadership = admin || hasScope(EXEC_PORTAL_SCOPE);
  return {
    reader: leadership || hasScope(ROADMAP_READ_SCOPE),
    leadership,
    canRun: admin,
    canEditTeams: leadership || hasScope(ROADMAP_EDIT_TEAMS_SCOPE),
  };
}
